const phoneNumber = "+7 495 555-35-35";

export default phoneNumber;
